import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('mbw-43-allow-status-mapping-on-business-board');
	},
};
